import { Effect } from "../../Materials/effect";
var name = 'fogVertex';
var shader = "#ifdef FOG\nvFogDistance=(view*worldPos).xyz;\n#endif";
Effect.IncludesShadersStore[name] = shader;
/** @hidden */
export var fogVertex = { name: name, shader: shader };
//# sourceMappingURL=fogVertex.js.map